import type { Attachment, Message } from "@lumen/shared";
import { GameAssetPreview } from "../game-assets/GameAssetPreview";
import { GameAssetLinks } from "../game-assets/GameAssetLinks";

export function MessageAttachments({ message }: { message: Message }) {
  if (!message.attachments?.length) return null;
  return (
    <div className="mt-4 flex flex-wrap gap-3">
      {message.attachments.map((file: Attachment) =>
        file.mimeType.startsWith("audio/") ? (
          <audio key={file.id} controls className="max-w-full" src={file.url}>
            <a href={file.url}>{file.name}</a>
          </audio>
        ) : file.mimeType.startsWith("video/") ? (
          <video
            key={file.id}
            controls
            className="max-h-[32rem] max-w-full rounded-xl"
            src={file.url}
          />
        ) : file.mimeType.startsWith("image/") ? (
          <div
            key={file.id}
            className="max-w-md rounded-xl border border-stone-200 p-3 dark:border-white/10"
          >
            <GameAssetPreview asset={file} />
            <div className="mt-2 truncate text-xs font-semibold">
              {file.name}
            </div>
            <GameAssetLinks asset={file} />
          </div>
        ) : (
          <div
            key={file.id}
            className="max-w-md rounded-xl border border-stone-200 p-3 dark:border-white/10"
          >
            <GameAssetPreview asset={file} />
            <div className="mt-2 truncate text-xs font-semibold">
              {file.name}
            </div>
            <GameAssetLinks asset={file} />
          </div>
        ),
      )}
    </div>
  );
}
